<template>
    <div>
        <section v-if="systemComponents.length > 0">
            <h4 class="text-sm font-semibold text-gray-700">{{ $t('System components') }}</h4>
            <p class="mt-1 text-xs leading-5 text-gray-500">
                {{ $t('Core workspace functions that can later be managed by users within the scope enabled by an administrator.') }}
            </p>
            <user-system-feature-list
                :features="systemComponents"
                :role-group="roleGroup"
                :value="value"
                @change="$emit('change', $event)"
            />
        </section>

        <section v-if="systemExtensions.length > 0" :class="{'mt-6': systemComponents.length > 0}">
            <h4 class="text-sm font-semibold text-gray-700">{{ $t('System extensions') }}</h4>
            <p class="mt-1 text-xs leading-5 text-gray-500">
                {{ $t('Optional function packages that are enabled exclusively by administrators.') }}
            </p>
            <user-system-feature-list
                :features="systemExtensions"
                :role-group="roleGroup"
                :value="value"
                @change="$emit('change', $event)"
            />
        </section>
    </div>
</template>

<script>
import {
    getUserSystemFeatures,
    USER_SYSTEM_FEATURE_CATEGORIES,
} from '@/utils/user-system-features';
import UserSystemFeatureList from '@/components/users/user-system-feature-list';

export default {
    name: 'user-system-feature-settings',
    components: {UserSystemFeatureList},
    props: {
        value: {
            type: Object,
            required: true,
        },
        roleGroup: {
            type: String,
            required: true,
        },
    },
    emits: ['change'],
    computed: {
        systemComponents() {
            return getUserSystemFeatures(USER_SYSTEM_FEATURE_CATEGORIES.COMPONENT, this.roleGroup);
        },
        systemExtensions() {
            return getUserSystemFeatures(USER_SYSTEM_FEATURE_CATEGORIES.EXTENSION, this.roleGroup);
        },
    },
};
</script>
